import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { MapboxOverlay } from '@deck.gl/mapbox';
import { getMapTooltip } from './tooltip.js';

// Labeled dark base: street and place names for orientation, kept muted by the
// dark palette so the live data still leads. (Carto has no street-only variant.)
const DARK_STYLE = 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json';

export interface MapShell {
  map: maplibregl.Map;
  overlay: MapboxOverlay;
}

export function createMapShell(container: string): MapShell {
  const map = new maplibregl.Map({
    container,
    style: DARK_STYLE,
    center: [-73.97, 40.74],
    zoom: 13,
    pitch: 0,
    attributionControl: {
      compact: true,
      customAttribution: ['Aircraft data © adsb.lol (ODbL)', 'Flood data: FloodNet / FieldKit'],
    },
  });
  // Overlaid (not interleaved): a separate deck canvas on top of the base map.
  // Picking/tooltips are reliable in this mode; the RainViewer radar is a base-map
  // raster so it still sits below the deck bullets/stations.
  const overlay = new MapboxOverlay({ interleaved: false, layers: [], getTooltip: getMapTooltip });
  map.addControl(overlay as unknown as maplibregl.IControl);
  return { map, overlay };
}
